import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React, { createContext, useContext, useMemo, useRef, ReactNode } from "react";

import { GRAPHQL_URL } from "./env";

import { GraphQLClient } from "../node_modules/graphql-request/build/entrypoints/main";

interface GqlContextType {
  queryClient: QueryClient;
  graphQLClient: GraphQLClient;
}

export const GqlContext = createContext<GqlContextType | undefined>(undefined);

export const GqlProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const queryClientRef = useRef<QueryClient | null>(null);
  const graphQLClientRef = useRef<GraphQLClient | null>(null);

  const value = useMemo(() => {
    if (!queryClientRef.current) {
      queryClientRef.current = new QueryClient();
    }
    if (!graphQLClientRef.current) {
      graphQLClientRef.current = new GraphQLClient(GRAPHQL_URL, {
        credentials: `include`,
      });
    }
    return {
      queryClient: queryClientRef.current,
      graphQLClient: graphQLClientRef.current,
    };
  }, []);

  return (
    <QueryClientProvider client={value.queryClient}>
      <GqlContext.Provider value={value}>
        {children}
      </GqlContext.Provider>
    </QueryClientProvider>
  );
};

export const useGqlContext = (): GqlContextType => {
  const context = useContext(GqlContext);
  if (!context) {
    throw new Error("useGqlContext must be used within a GqlProvider");
  }
  return context;
};
